import { Button } from '@/shared/components/ui/button'

export default function QuotationActions({
  onCancel,
  onCreate,
  isEditMode = false,
}) {
  return (
    <div className="mt-8 flex flex-col-reverse sm:flex-row justify-end gap-3 border-t pt-6">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        className="w-full sm:w-auto"
      >
        Cancel
      </Button>

      <Button
        type="button"
        onClick={onCreate}
        className="w-full sm:w-auto bg-gray-900 hover:bg-gray-900"
      >
        {isEditMode ? 'Save Changes' : 'Create Quotation'}
      </Button>
    </div>
  )
}
